/**
 * config/constants.js
 * Shared constants: API URL, TLP, colors, print CSS
 */

export const API = process.env.NODE_ENV === "development"
  ? "http://localhost:8000"
  : "https://nexgen-backend-60om.onrender.com";

export const TLP_OPTIONS = [
  { value: "WHITE",  label: "TLP:WHITE — Unrestricted",        color: "#1A1A2E", bg: "#F0F4FF" },
  { value: "GREEN",  label: "TLP:GREEN — Community",           color: "#1B5E20", bg: "#E8F5E9" },
  { value: "AMBER",  label: "TLP:AMBER — Organization only",   color: "#E65100", bg: "#FFF3E0" },
  { value: "RED",    label: "TLP:RED — Named recipients only", color: "#B71C1C", bg: "#FFEBEE" },
];

export const SEVERITY_COLORS = {
  critical: "#D32F2F",
  high:     "#F57C00",
  medium:   "#F9A825",
  low:      "#388E3C",
  info:     "#1565C0",
  unknown:  "#546E7A",
};

export const SEVERITY_BG = {
  critical: "#FFEBEE",
  high:     "#FFF3E0",
  medium:   "#FFFDE7",
  low:      "#E8F5E9",
  info:     "#E3F2FD",
  unknown:  "#ECEFF1",
};

export const CHART_COLORS = [
  "#1565C0","#C62828","#2E7D32","#F57F17","#6A1B9A",
  "#00695C","#AD1457","#0277BD","#4E342E","#37474F",
  "#283593","#558B2F","#E65100","#4527A0","#00838F",
];

export const PRINT_CSS = `
  @media print {
    * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
    body { background: #FFFFFF !important; color: #1A1A2E !important; font-family: Arial, sans-serif; margin: 0; padding: 0; }
    .no-print { display: none !important; }
    .page-break { page-break-before: always; }
    .report-section { page-break-inside: avoid; margin-bottom: 24px; }
    .report-card { background: #FFFFFF !important; border: 1px solid #E0E0E0 !important; border-radius: 8px; padding: 20px; margin-bottom: 16px; }
    .report-card h2, .report-card h3 { color: #1A1A2E !important; }
    table { border-collapse: collapse; width: 100%; }
    th { background: #F5F5F5 !important; color: #1A1A2E !important; }
    td { border-bottom: 1px solid #E0E0E0; }
    .chart-container { page-break-inside: avoid; }
    a { color: #1565C0 !important; }
  }
  @page { size: A4; margin: 20mm 15mm; }
`;
